import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigurationService } from 'mbs-ui-shared@services/configuration.service';
import { Observable } from 'rxjs';

@Injectable()
export class AlertNotificationService {
  private serverUrl: string;
  private mbsStageKey: string;

  constructor(private http: HttpClient, private config: ConfigurationService) {
    this.serverUrl = this.config.get('rmmBaseHref');
    this.mbsStageKey = this.config.get('mbsStageKey');
  }

  saveAlertNotification(payload: any): Observable<any> {
    let params = {};
    if (this.mbsStageKey) params = { mbsStageKey: this.mbsStageKey };
    return this.http.post(`${this.serverUrl}/api/notificationConfig`, payload, params);
  }
}
